import React from 'react';
import { BannerReact } from 'common/components/banner';
import { BannerAction, BannerSize, BannerTheme, BannerType } from 'common/components/banner/types';
import styles from './index.module.styl';
type DogfoodingBannerProps = {
  percentComplete: number;
  slackChannelName: string;
  slackChannelId: string;
  projectId?: number;
};
const DOGFOOD_PROJECT_IDS = new Set([3, 8]);
export function DogfoodingBanner(_ref: DogfoodingBannerProps) {
  let {
    percentComplete,
    slackChannelName,
    slackChannelId,
    projectId
  }: DogfoodingBannerProps = _ref;
  const [isOpen, setIsOpen] = React.useState(DOGFOOD_PROJECT_IDS.has(projectId !== null && projectId !== void 0 ? projectId : 0));
  return isOpen && <div className={styles.wrapper}>
        <BannerReact theme={BannerTheme.Base} type={BannerType.Embedded} size={BannerSize.Small} icon={"feedback"} ctas={[{
      text: "Dismiss",
      actionName: BannerAction.Dismiss
    }]} onAction={ev => ev.detail.actionName === BannerAction.Dismiss && setIsOpen(false)}>
          <div slot='body-text'>
            <strong>Dogfooding:</strong> Please share feedback on <strong>functionality</strong> and{" "}
            <strong>design</strong> in{" "}
            <a href={"https://mixpanel.slack.com/archives/".concat(slackChannelId)} className={styles.slackLink} target='_blank' rel='noreferrer'>{"#".concat(slackChannelName)}</a>
            {" "}({percentComplete.toString()}% design complete)
          </div>
        </BannerReact>
      </div>;
}